import React, { useContext, useEffect} from 'react';
 import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 

import tbl from '../../../../assets/Style/Table.module.css'
import { useMessage } from '../../../../hooks/useMessage';
 import { useTranslation } from 'react-i18next';
 
const List = () => {
    const {t} = useTranslation();
 
  const {appState, app} = useContext(AppContext);
  const formatDate = (dateString) => {
    const createdAtDate = new Date(dateString);

    const months = [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')];


    const day = createdAtDate.getDate();
    const month = months[createdAtDate.getMonth()];
    const year = createdAtDate.getFullYear();
    const hours = createdAtDate.getHours().toString().padStart(2, '0');  
    const minutes = createdAtDate.getMinutes().toString().padStart(2, '0');  

    return `${day} ${month} ${year} ${hours}:${minutes}`; 
};

  
  const { messageService } = useMessage(50); 

  useEffect( ()=> {
    messageService.fetchList()
  }, [])

  function getTypeName(type) {
    switch(type) {
      case 1:
        return "SYSTEM";
      case 2:
        return "ONE";
      case 3:
        return "BULK";
      default:
        return "UNKNOWN";
    }
  }
   
  return <div>

    <div className={ cl.headMain }> 
        <h1>SMS</h1>   
     </div>
 
    <div className={tbl.table + ' ' + cl.table}>
 
      <table>
        <thead>
            <tr>
            <th className={cl.id} >#</th>
            <th>{t('Message')}</th>
            <th>{t('Type')}</th>
            <th>{t('Phone')}</th> 
            <th>{t('Email')}</th>  
            <th>{t('Sent')}</th>   
            <th>{t('Delivered')}</th>    
            <th>{t('Email')}</th>     
            <th>{t('CarID')}</th>      
            <th>{t('Date')}</th>  
            </tr>
        </thead>
        <tbody>
            {messageService.items.map((item) =>
              <tr key={item.id} className={item.delivered ? '' :  cl.redTable}  >
                <td className={cl.id} >{item.id} </td>
                <td>{item.text}   </td>
                <td>{getTypeName(item.type)}</td>
                <td>{item.mobile}</td>
                <td>{item.email}</td>
                <td>
                {item.sent ? (
                    <span style={{ color: 'green' }}>✔</span>
                ) : ''}
            </td>
            <td>
                {item.delivered ? (
                    <span style={{ color: 'green' }}>✔</span>
                ) : ''}
            </td>
            <td>
                {item.sent_email ? (
                    <span style={{ color: 'green' }}>✔</span>
                ) : ''}
            </td>
                <td>{item.car_id}</td> 
                <td> {formatDate(item.created_at)}</td>

              </tr>  
            )}
        </tbody>
      </table>


    </div>

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={messageService.total} 
                perPage={messageService.filter.limit} 
                current={messageService.filter.page} 
                paginate={(page) => {
                  messageService.setFilter({
                    ...messageService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                  messageService.setFilter({
                    ...messageService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default List;